module.exports = {"130724100":"平定堡镇","130724101":"小厂镇","130724102":"黄盖淖镇","130724103":"九连城镇","130724200":"高山堡乡","130724201":"小河子乡","130724202":"二道渠乡","130724203":"大二号回族乡","130724204":"闪电河乡","130724205":"长梁乡","130724206":"丰源店乡","130724207":"西辛营乡","130724208":"莲花滩乡","130724209":"白土窑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130724.json
// module id = 169
// module chunks = 0